import * as constants from './constants'

export const getSubscriptionsHistory = () => ({
    type: constants.GET_SUBSCRIPTIONS_HISTORY,
})

export const setSubscriptionsHistory = data => ({
    type: constants.SET_SUBSCRIPTIONS_HISTORY,
    data,
})

export const updateSubscription = data => ({
    type: constants.UPDATE_SUBSCRIPTION,
    data,
})

export const getSubscriptionInvoices = subscriptionId => ({
    type: constants.GET_SUBSCRIPTION_INVOICES,
    subscriptionId,
})

export const getSubscriptionReceipts = subscriptionId => ({
    type: constants.GET_SUBSCRIPTION_RECEIPTS,
    subscriptionId,
})

export const setSubscriptionInvoices = data => ({
    type: constants.SET_SUBSCRIPTION_INVOICES,
    data,
})

export const setSubscriptionReceipts = data => ({
    type: constants.SET_SUBSCRIPTION_RECEIPTS,
    data,
})

export const payInvoice = data => ({
    type: constants.PAY_INVOICE,
    data,
})

export const setSubscription = updatedSubscription => ({
    type: constants.SET_SUBSCRIPTION,
    updatedSubscription,
})

export const downloadInvoice = invoiceId => ({
    type: constants.DOWNLOAD_INVOICE,
    invoiceId,
})

export const downloadReceipt = (subscriptionId, paymentNumber) => ({
    type: constants.DOWNLOAD_RECEIPT,
    subscriptionId,
    paymentNumber,
})

export const assignParker = data => ({
    type: constants.ASSIGN_PARKER,
    data,
})

export const removeParker = (subscriptionId, memberId) => ({
    type: constants.REMOVE_PARKER,
    subscriptionId,
    memberId,
})

export const savePadData = data => ({
    type: constants.SAVE_PAD_DATA,
    data,
})

export const getWaitList = () => ({
    type: constants.GET_WAIT_LIST,
})

export const setWaitList = waitList => ({
    type: constants.SET_WAIT_LIST,
    waitList,
})
export const deleteWaitListItem = (waitListId, locale) => ({
    type: constants.DELETE_WAIT_LIST_ITEM,
    waitListId,
    locale,
})
